import {connect} from "react-redux";
import * as CoursesActions from '../../store/actions/coursesActions';
import SettingsAdmin from '../../components/AdminPanel/SettingsAdmin';

const mapStateToProps = (state) => ({
    ...state.auth,
    ...state.courses
});

const mapDispatchToProps = (dispatch, state) => ({
    onLoadCourses: (uid, token) => {
        dispatch(CoursesActions.getCoursesForAdmin(uid, token));
    },
    loadTestsByUID: (uid, token) => {
        dispatch(CoursesActions.getTestsByUID(uid, token));

    },
    loadTest: (id) => {

    },
    updateCourse: (data, uid, token) => {
        dispatch(CoursesActions.updateCourse(data, uid, token));
    },
    addTest: (data, token) => {
        dispatch(CoursesActions.addTest(data, token));
    },
    updateTest: (data, token) => {
        dispatch(CoursesActions.updateTest(data, token));

    },
    deleteTest: (id, token) => {
        dispatch(CoursesActions.deleteTest(id, token));
    },
    onLoadSubjects: (uid, token) => {
        dispatch(CoursesActions.getSubjectsForAdmin(uid, token));
    },
    removeChapterConfirmation: (id, token) => {
        dispatch(CoursesActions.removeChapterPart(id, token));
    },
    hideModalDelete: () => {
        dispatch(CoursesActions.hideModalDeletePart());
    },
    editChapterInfo: (chapter, subjectId, uid, token) => {
        dispatch(CoursesActions.editChapterInformation(chapter, subjectId, uid, token));
    },
    addNewChapter: (chapter, subjectId, uid, token) => {
        dispatch(CoursesActions.addChapter(chapter, subjectId, uid, token));
    },
    deleteOneChapter: (id, token) => {
        dispatch(CoursesActions.deleteChapter(id, token));
    },
    addNewSubject: (subject, courseId, userId, token) => {
        dispatch(CoursesActions.addNewSubject(subject, courseId, userId, token));
    },
    addNewCourse: (course, token) => {
        dispatch(CoursesActions.addNewCourse(course, token));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(SettingsAdmin);


// WEBPACK FOOTER //
// ./src/containers/AdminPanel/SettingsAdminContainer.js